export default __webpack_public_path__ + "5e5c403ced7cbc7b7222eed15dd6323f.png";